import type { JSX } from 'react';
import { Box, styled } from '@mui/material';
import {
  DISEASE_BURDEN_LOD,
  DISEASE_BURDEN_VALUE_COLOURS,
  POPUP_BURDEN_COLUMNS,
} from '@/constants/PatientDashboard/patientTimeline';
import type { ITimelinePopupBurdenGroup } from '@/types/PatientDashboard/PatientTimeline.types';
import AssayMarker from './AssayMarker';
import { formatChartValue } from './ChartLane.util';
import {
  PopupRow, PopupRowName, PopupRowText, PopupValueCell,
} from './TimelinePopup.styles';

const [purityColumn, lodColumn] = POPUP_BURDEN_COLUMNS;

const GroupRoot = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
});

const BurdenValue = styled(PopupValueCell)({
  fontWeight: 700,
});

const LodValue = styled(BurdenValue)({
  color: DISEASE_BURDEN_LOD.colour,
});

interface IProps {
  group: ITimelinePopupBurdenGroup;
}

export default function TimelinePopupBurdenGroup({ group }: IProps): JSX.Element {
  return (
    <GroupRoot>
      <PopupRowText truncate>{group.analyte}</PopupRowText>
      {group.rows.map((row) => (
        <PopupRow key={row.key}>
          <AssayMarker assay={row.assay} colour={group.colour} isDetected={row.isDetected} />
          <PopupRowName truncate>{row.assayLabel}</PopupRowName>
          <BurdenValue
            style={{
              width: purityColumn.width,
              color: row.isDetected
                ? DISEASE_BURDEN_VALUE_COLOURS.detected
                : DISEASE_BURDEN_VALUE_COLOURS.notDetected,
            }}
          >
            {formatChartValue(row.purity)}
          </BurdenValue>
          <LodValue style={{ width: lodColumn.width }}>
            {formatChartValue(row.lod)}
          </LodValue>
        </PopupRow>
      ))}
    </GroupRoot>
  );
}
